import React from "react"
import { Link } from "gatsby"

import cx from "classnames"
import * as s from "./post-image.module.sass"

const PostImage = (props) => {
  const { image, to, parentClass, fullsize = false } = props

  const componentClass = cx({
    [s.component]: true,
    [s.noImage]: !image,
    [s.link]: to,
    [parentClass]: parentClass,
  })

  if (!image || !image.formats) {
    return <figure className={componentClass} />
  }

  const originalUrl = process.env.API_URL + image.url;
  const originalWidth = image.width;
  const { small, medium, large } = image.formats
  const smallUrl = process.env.API_URL + small.url
  const mediumUrl = process.env.API_URL + medium.url
  const largeUrl = process.env.API_URL + large.url
  const srcSet = `
    ${smallUrl} 500w,
    ${mediumUrl} 750w,
    ${largeUrl} 1000w,
    ${originalUrl} ${originalWidth}w
  `
  const maxWidth = fullsize ? 1140 : 680;

  const img = (
    <img
      src={smallUrl}
      srcSet={srcSet}
      sizes={`(max-width: 680px) 100vw, ${maxWidth}px`}
    />
  )

  if (to) {
    return (
      <Link to={to} className={componentClass}>
        {img}
      </Link>
    )
  }

  return <figure className={componentClass}>{img}</figure>
}

export default PostImage
